module.exports = __webpack_public_path__ + "static/media/about.b8f772d9.svg";